import _ from 'lodash'
import firebase from 'firebase/app'
import { ContactType } from '@/modules/pass/types/contactType'
import moment from 'moment'
import Timestamp = firebase.firestore.Timestamp

export class Contact {
  type?: ContactType | null
  value?: string | null
  name?: string | null

  constructor (type?: ContactType, value?: string, name?: string) {
    this.type = type || null
    this.value = value || null
    this.name = name || null
  }
}

export class DynamicProperties {
  lastChange?: Timestamp
  lastChangeMoment?: moment.Moment | null
  detail?: string
  news?: string
  openingHour?: string
  warning?: string
  info?: string
  covid?: string
  contacts: Array<Contact> = []

  constructor (lastChange: Timestamp,
    news: string,
    openingHour: string,
    warning: string,
    info: string,
    covid: string,
    contacts: Array<Contact>) {
    this.lastChange = lastChange
    this.lastChangeMoment = lastChange ? moment(lastChange.toMillis()) : null
    this.news = news
    this.openingHour = openingHour
    this.warning = warning
    this.info = info
    this.covid = covid
    this.contacts = contacts
  }
}

export default class Pass {
  id: string
  name: string
  draftProps: DynamicProperties
  publishedProps: DynamicProperties

  constructor (id: string, name: string, draftProps: DynamicProperties, publishedProps: DynamicProperties) {
    this.id = id
    this.name = name
    this.draftProps = draftProps
    this.publishedProps = publishedProps
  }

  get hasChange () {
    return !_.isEqual(_.omit(this.draftProps, 'lastChange', 'lastChangeMoment'), _.omit(this.publishedProps, 'lastChange', 'lastChangeMoment'))
  }

  publish () {
    this.draftProps.lastChange = firebase.firestore.FieldValue.serverTimestamp() as Timestamp
    this.draftProps.lastChangeMoment = moment() // fix it -> should be taken from server
    this.publishedProps = _.cloneDeep(this.draftProps)
  }
}
